import { rankingItems } from '@/mocks/homeData';

const changeIcons: Record<string, { icon: string; cls: string }> = {
  up: { icon: 'ri-arrow-up-fill', cls: 'text-primary-500' },
  down: { icon: 'ri-arrow-down-fill', cls: 'text-accent-600' },
  new: { icon: 'ri-sparkling-fill', cls: 'text-accent-500' },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-3">
            热播榜单
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            本周热播排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            最受欢迎的高清电影全集，热门大片播放量实时排名
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, i) => {
              const change = changeIcons[item.change];
              return (
                <div
                  key={item.id}
                  className={`flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                    i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
                  }`}
                >
                  <div className="w-8 h-8 flex items-center justify-center">
                    {item.rank <= 3 ? (
                      <span
                        className={`text-lg font-bold ${
                          item.rank === 1
                            ? 'text-primary-500'
                            : item.rank === 2
                              ? 'text-accent-500'
                              : 'text-secondary-500'
                        }`}
                      >
                        {item.rank}
                      </span>
                    ) : (
                      <span className="text-sm font-semibold text-foreground-400">
                        {item.rank}
                      </span>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.hot}</span>
                    <i className={`${change.icon} ${change.cls} text-sm`}></i>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}